import { expVal } from '@atlassian/jira-feature-experiments';

export type UseIsViewTemplateButtonVisibleProps = {
	canCreateFields: boolean;
	canManageViews: boolean;
	projectId?: string;
	projectKey?: string;
};

export const useIsViewTemplateButtonVisible = ({
	canCreateFields,
	canManageViews,
	projectId,
	projectKey,
}: UseIsViewTemplateButtonVisibleProps): boolean =>
	Boolean(
		canCreateFields &&
		canManageViews &&
		projectId &&
		projectKey &&
		(expVal('view-template-library-m1-for-new-tenants', 'isEnabled', false) ||
			expVal('view-template-library-m1-for-existing-tenants', 'isEnabled', false)),
	);
